/* unplugin-vue-components disabled */import script from "./user-withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./user-withdraw.vue?vue&type=script&setup=true&lang=js"

import "./user-withdraw.vue?vue&type=style&index=0&id=6e62c7d4&lang=scss"

const __exports__ = script;

export default __exports__